import {HelperOptions} from 'handlebars';

/**
 * Helper for checking if a value can be considered "empty".
 *
 * @param {any} value Value to check
 * @param {HelperOptions} options Helper options
 * @returns {string|null}
 * @author Philipp Seiler <sep@earlybird.at>
 */
const ifEmpty = (value: any, options: HelperOptions): string | null => {
  const isEmpty = value === undefined || typeof value === 'undefined' || !value;
  if (options.hash.hasOwnProperty('then') || options.hash.hasOwnProperty('else')) {
    if (isEmpty) {
      if (options.hash.hasOwnProperty('then')) {
        return options.hash.then;
      }
      return null;
    } else {
      if (options.hash.hasOwnProperty('else')) {
        return options.hash.else;
      }
      return null;
    }
  } else {
    return isEmpty ? options.fn(this) : options.inverse(this);
  }
};
export default ifEmpty;
